<template>
<div class="main">
  <FormHero :formtype="'shortlist'" :stage="'yoursit'" :agentdata="[]"></FormHero>

  <div class="container ut-px-4">

    <address-search v-if="!manualAddress" v-gaEvent="{ category: gacategory, action: 'Click Property Address Field', label: ''}" class="" @selectedResult="getAddress"></address-search>
    <div v-if="errors.addressError" class="hasDanger">Address is required</div>

    <div class="checkboxclass">
      <input type="checkbox" id="manualAddresscheckbox" v-model="manualAddress">
      <label for="manualAddresscheckbox" class="ut-text-sm ut-text-N400"> I can't find my address in the list</label>
    </div>

    <div v-if="manualAddress" class="manualsection">
      <input type="text" v-model="manualStreetAddress" class="form-control" v-gaEvent="{ category: gacategory, action: 'Click Manual Street Address Field', label: ''}" placeholder="Street Address">

      <SuburbSearch class="suburbsearch" :placeholderText="'Suburb'" @selectedResult="getSuburb"></SuburbSearch>
    </div>

    <label class="ut-block ut-pt-4" :class="{hasDanger: errors.pricerangeError}">What is your expected price range?</label>
    <div class="ut-flex ut-flex-wrap ut-flex-auto ut-justify-between ut-py-4">

      <div class="ut-m-0 md:ut-flex">
        <RadioButton id="range1" v-model="pricerange" :name="'range1'" :radioValue="'high400000'" :selectedValue="pricerange" :gacategory="gacategory" :galabel="'high400000'" :gaaction="'Click Expected Sales Price Field'">Less than $400K</RadioButton>

        <RadioButton id="range2" v-model="pricerange" class="ut-pt-2 md:ut-pt-0" :name="'range2'" :radioValue="'mid600000'" :selectedValue="pricerange" :gacategory="gacategory" :galabel="'mid600000'" :gaaction="'Click Expected Sales Price Field'">$400k
          to $600K</RadioButton>
      </div>

      <div class="radiodiv2 ut-m-0 md:ut-flex md:ut-m-0">
        <RadioButton id="range3" class="range3 ut-pt-2 md:ut-pt-2" v-model="pricerange" :name="'range3'" :radioValue="'mid900000'" :selectedValue="pricerange" :gacategory="gacategory" :galabel="'mid900000'" :gaaction="'Click Expected Sales Price Field'">$600K
          to $900K</RadioButton>

        <RadioButton id="range4" class="ut-pt-2 md:ut-pt-2" v-model="pricerange" :name="'range4'" :radioValue="'low9000000'" :selectedValue="pricerange" :gacategory="gacategory" :galabel="'low9000000'" :gaaction="'Click Expected Sales Price Field'">More
          than $900K</RadioButton>
      </div>
    </div>


    <label class="ut-block ut-pt-4" :class="{hasDanger: errors.sellingwhyError}">Why are you selling?</label>
    <div class="sellingwhy ut-py-4">

      <div class="block1 md:ut-flex">
        <RadioButton id="selling1" v-model="sellingwhy" :name="'selling1'" :radioValue="'Relocating'" :selectedValue="sellingwhy" :gacategory="gacategory" :galabel="'Relocating'" :gaaction="'Click Why are you Selling Option'">Relocating</RadioButton>

        <RadioButton id="selling2" v-model="sellingwhy" :name="'selling2'" :radioValue="'Investment property'" :selectedValue="sellingwhy" :gacategory="gacategory" :galabel="'Investment property'" :gaaction="'Click Why are you Selling Option'">Investment property</RadioButton>

        <RadioButton id="selling3" v-model="sellingwhy" :name="'selling3'" :radioValue="'Downsizing'" :selectedValue="sellingwhy" :gacategory="gacategory" :galabel="'Downsizing'" :gaaction="'Click Why are you Selling Option'">Downsizing</RadioButton>
      </div>

      <div class="block2 md:ut-flex md:ut-mt-2">
        <RadioButton id="selling4" v-model="sellingwhy" :name="'selling4'" :radioValue="'Upsizing'" :selectedValue="sellingwhy" :gacategory="gacategory" :galabel="'Upsizing'" :gaaction="'Click Why are you Selling Option'">Upsizing</RadioButton>

        <RadioButton id="selling5" v-model="sellingwhy" :name="'selling5'" :radioValue="'Family situation'" :selectedValue="sellingwhy" :gacategory="gacategory" :galabel="'Family situation'" :gaaction="'Click Why are you Selling Option'">Family situation</RadioButton>

        <RadioButton id="selling6" v-model="sellingwhy" :name="'selling6'" :radioValue="'Deceased estate'" :selectedValue="sellingwhy" :gacategory="gacategory" :galabel="'Deceased estate'" :gaaction="'Click Why are you Selling Option'">Deceased estate</RadioButton>
      </div>

    </div>

    <label class="ut-block" :class="{hasDanger: errors.sellingtimeError}">What is your selling time?</label>
    <div class="ut-flex ut-pt-4">
      <RadioButton id="sellingtime1" v-model="sellingtime" :name="'sellingtime1'" :radioValue='"3 - 6 months"' :selectedValue="sellingtime" :gacategory="gacategory" :galabel="'3 - 6 months'" :gaaction="'Click When are you Selling Option'">3 months</RadioButton>

      <RadioButton id="sellingtime2" v-model="sellingtime" :name="'sellingtime2'" :radioValue='"6 - 12 months"' :selectedValue="sellingtime" :gacategory="gacategory" :galabel="'6 - 12 months'" :gaaction="'Click When are you Selling Option'">6 months</RadioButton>

      <RadioButton id="sellingtime3" v-model="sellingtime" :name="'sellingtime3'" :radioValue='"I don’t know / > 12months"' :selectedValue="sellingtime" :gacategory="gacategory" :galabel="'I don’t know / > 12months'" :gaaction="'Click When are you Selling Option'">12
        months</RadioButton>
    </div>

    <button class="ut-oa-btn ut-mt-12 ut-block ut-mb-8" :to="{name: 'PersonalisedShortlistStep2'}" @click="validate()" v-gaEvent="{ category: gacategory, action: 'Click Next Step', label: ''}">Next step</button>

  </div>
</div>
</template>

<script>
import axios from 'axios';
import AddressSearch from '@/components/forms/search/AddressSearch.vue';
import FormHero from '@/components/FormHero.vue';
import RadioButton from '@/components/forms/RadioButton.vue';
import SuburbSearch from '@/components/forms/search/SuburbSearch.vue';

export default {
  name: 'PersonalisedShortlistStep1',
  props: {
    gaaction: null,
    galabel: null,
  },
  components: {
    AddressSearch,
    FormHero,
    RadioButton,
    SuburbSearch,
  },

  data() {
    return {
      gacategory: 'Personalised Short List Form',
      addressvar: null,
      pricerange: null,
      lowpricerange: null,
      highpricerange: null,
      sellingwhy: null,
      sellingtime: null,
      suburbvar: null,
      manualAddress: false,
      manualStreetAddress: null,
      postcodeid: null,
      errors: {
        addressError: false,
        pricerangeError: false,
        sellingwhyError: false,
        sellingtimeError: false,
      },
    };
  },
  methods: {
    getAddress(selected) {
      this.addressvar = selected;
      axios.get(`${process.env.VUE_APP_API_URL}/postcoderest/find/${selected.details.suburb}`)
        .then((res) => {
          this.postcodeid = res.data.data[0].id;
        });
    },
    getSuburb(selected) {
      this.suburbvar = selected;
    },
    validate() {

      let streetaddress;

      this.lowpricerange = null;
      this.highpricerange = null;

      let hasError = false;

      if (this.manualAddress) {
        if (!this.manualStreetAddress || !this.suburbvar) {
          hasError = true;
          this.errors.addressError = true;
        } else {
          this.errors.addressError = false;
          streetaddress = this.manualStreetAddress;
          this.postcodeid = this.suburbvar.id;
        }

      } else {
        if (!this.addressvar) {
          hasError = true;
          this.errors.addressError = true;
        } else {
          this.errors.addressError = false;
          streetaddress = this.addressvar.details.streetaddress;
        }
      }

      if (!this.pricerange) {
        hasError = true;
        this.errors.pricerangeError = true;
      } else {
        this.errors.pricerangeError = false;
        if (this.pricerange.includes('low')) {
          this.lowpricerange = this.pricerange.replace('low', '');
        } else if (this.pricerange.includes('high')) {
          this.highpricerange = this.pricerange.replace('high', '');
        } else if (this.pricerange.includes('mid600000')) {
          this.highpricerange = this.pricerange.replace('mid', '');
          this.lowpricerange = '400000';
        } else if (this.pricerange.includes('mid900000')) {
          this.highpricerange = this.pricerange.replace('mid', '');
          this.lowpricerange = '600000';
        }
      }

      if (!this.sellingwhy) {
        hasError = true;
        this.errors.sellingwhyError = true;
      } else {
        this.errors.sellingwhyError = false;
      }

      if (!this.sellingtime) {
        hasError = true;
        this.errors.sellingtimeError = true;
      } else {
        this.errors.sellingtimeError = false;
      }

      if (!hasError) {
        this.shortlistdata = {
          addressdata: (this.addressvar != null ? this.addressvar : this.suburbvar),
          streetaddress: streetaddress,
          lowpricerange: this.lowpricerange,
          highpricerange: this.highpricerange,
          reasonforsale: this.sellingwhy,
          sellingtime: this.sellingtime,
          name: null,
          email: null,
          phone: null,
          postcodeid: this.postcodeid,
        };
        console.log(this.shortlistdata);
        this.$store.state.shortlistdata = this.shortlistdata;

        this.$router.push({
          path: '/shortlist/step2',
        });
      }
    },
  },
  computed: {},
  created() {},
};
</script>

<style scoped lang="scss">
.main {
    max-width: 600px;
    margin: 0 auto;

    @media (min-width: 363px) and (max-width: 767px) {
        .radiodiv2 {
            margin: auto;
            .range3 {
                padding-top: 0;
            }
        }
    }
    .checkboxclass {
        input {
            width: unset !important;
        }
    }

    @media (max-width: 767px) {
      .sellingwhy {
        .block1, .block2 {
          display: inline-block;
          width: 50%;

          @media (max-width: 410px) {
            width: 100%;
          }
        }
      }
    }
}
</style>
